import { render, staticRenderFns } from "./TableMateria.vue?vue&type=template&id=13985fe2"
import script from "./TableMateria.vue?vue&type=script&lang=js"
export * from "./TableMateria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports